export const predefinedBackgrounds = [
  {
    id: 1,
    name: "Blue Gradient",
    url: "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=500&auto=format&fit=crop",
  },
  {
    id: 2,
    name: "Abstract Waves",
    url: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=500&auto=format&fit=crop",
  },
  {
    id: 3,
    name: "Nature Scene",
    url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=500&auto=format&fit=crop",
  },
  {
    id: 4,
    name: "Tech Pattern",
    url: "https://images.unsplash.com/photo-1639762681057-408e52192e55?w=500&auto=format&fit=crop",
  },
];